import { Component } from '@angular/core';
import { IonApp, IonRouterOutlet, IonMenu, IonContent, IonList, IonItem, IonIcon, IonLabel, IonTitle, IonToolbar, IonHeader, IonTabs, IonTabBar, IonTabButton, IonButtons, IonButton, IonInput, IonTextarea,IonSelect  } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { cloudUploadOutline, heartOutline, homeOutline, listOutline, settingsOutline } from 'ionicons/icons';
import { ThemeService } from './services/theme.service';
import { NotificationService } from './services/notification.service';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: true,
  imports: [IonApp, IonRouterOutlet, IonMenu, IonContent, IonList, IonItem, IonIcon, IonLabel, IonTitle, IonToolbar, IonHeader, IonTabs, IonTabBar, IonTabButton, IonLabel, IonButtons, IonButton, IonInput, IonTextarea,IonSelect],
})
export class AppComponent {
  constructor(private themeService: ThemeService, private notificationService: NotificationService) {
    addIcons({
      homeOutline,
      listOutline,
      cloudUploadOutline,
      heartOutline,
      settingsOutline,
    });
    this.notificationService.requestPermissions();
    this.notificationService.onNotificationReceived((notification) => {
      console.log('Local notification received', notification);
    });
    this.notificationService.onNotificationActionPerformed((action) => {
      console.log('Local notification action performed', action);
    });
  }
}
